import React from "react"
import PropTypes from "prop-types"

import { library } from '@fortawesome/fontawesome-svg-core'
import { faCheck, faAngleRight, faAngleLeft, faCheckSquare, faPhoneAlt, faWarehouse, faWallet, faAward, faUsers, faSmile, faComments } from "@fortawesome/free-solid-svg-icons"

library.add(faCheck, faAngleRight, faAngleLeft, faCheckSquare, faPhoneAlt, faWarehouse, faWallet, faAward, faUsers, faSmile, faComments)

const Layout = ({ children }) => {
  return (
    <>
      {children}
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
